/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createMachine } from 'xstate';

import { PaymentStep } from 'components/Flow/flows/nonprofitOnboardingPayment/components/PaymentStep';

import { NonprofitOnboardingMachineEvents } from '../nonprofitOnboarding/machine';

export const nonprofitOnboardingPaymentMachine = createMachine(
  {
    id: 'nonprofitOnboardingPaymentMachine',
    key: 'nonprofitOnboardingPaymentMachine',
    initial: 'initial',
    schema: {
      events: {} as NonprofitOnboardingMachineEvents,
    },
    states: {
      initial: {
        on: {
          ENROLL: {
            target: 'done',
            actions: ['openExternalLink'],
          },
          SKIP: {
            target: 'done',
          },
        },
        meta: {
          component: PaymentStep,
        },
      },
      done: {
        type: 'final',
        entry: ['handleFinal'],
      },
    },
    tsTypes: {} as import('./machine.typegen').Typegen0,
  },
  {
    actions: {
      openExternalLink: (_context, event): void => {
        if (event.location) {
          window.open(event.location, '_blank')?.focus();
        }
      },
    },
  }
);
